import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ApplicationState } from "../../store";
import { GenericActionCreator } from "../../store/LegacyStore/actions";
import { ThermostatType } from "../../store/LegacyStore/models";
import { getThermostatKey } from "./utility/enumKey";

type Props =
    ApplicationState &
    GenericActionCreator &
    ThermostatType

export function LegacyServerUrl(props: Props) {
    // Component state
    const [showModal, setShowModal] = React.useState(false);
    const [serverUrl, setServerUrl] = React.useState("");
    const thermostatKey = getThermostatKey(props.thermostatType);

    /**
     * Toggle modal visibility.
     */
    const toggleModalVisibility = () => {
        if (!showModal && props.legacy[thermostatKey].thermostats.length > 0) {
            setServerUrl(props.legacy[thermostatKey].thermostats[0].internalStorage.serverIp + ":" + props.legacy[thermostatKey].thermostats[0].internalStorage.serverPort);
        }
        setShowModal(!showModal);
    };

    /**
     * Validate server url. Returns undefined if server url is valid,
     * else a validation message is returned.
     */
    const validateServerUrl = () => {
        const sanitizedServerUrl = (serverUrl || "").trim();
        const urlParts = sanitizedServerUrl.split(":");

        if (sanitizedServerUrl === "") {
            return "Server url is required";
        } else if (urlParts.length !== 2) {
            return "Port is required";
        } else if (urlParts[0].trim() === "") {
            return "Host is invalid";
        } else if (isNaN(parseInt(urlParts[1]))) {
            return "Port is invalid";
        } else {
            return undefined;
        }
    };

    /**
     * Check if server url can be saved based on current application state.
     */
    const canSaveServerUrl = () => {
        return !validateServerUrl() && props.legacy[thermostatKey].thermostats.length > 0;
    };

    /**
     * Save server url and close modal.
     */
    const saveServerUrl = () => {
        const sanitizedServerUrl = (serverUrl || "").trim();
        const urlParts = sanitizedServerUrl.split(":");
        props.setServerUrl(urlParts[0], parseInt(urlParts[1]));
        toggleModalVisibility();
    };

    // Render
    return (
        <div className="btn text-bottom text-white" onClick={toggleModalVisibility}>
            Server URL
            <Modal isOpen={showModal} toggle={toggleModalVisibility}>
                <ModalHeader toggle={toggleModalVisibility}>What do you wish to set the Server URL to?</ModalHeader>
                <ModalBody>
                    <input
                        type="text"
                        className={`form-control ${!!validateServerUrl()}`}
                        value={serverUrl}
                        onChange={(e) => setServerUrl(e.target.value)} style={{ width: "-webkit-fill-available", outline: "none" }} />
                    <span className="font-weight-light">Server URL will only update on disconnected thermostats.</span>
                    <br />
                    <span className="text-danger">{validateServerUrl()}</span>
                </ModalBody>
                <ModalFooter>
                    {props.legacy[thermostatKey].thermostats.length > 0 ? null : <span className="text-danger">No thermostats to set server url on</span>}
                    <button
                        disabled={!canSaveServerUrl()}
                        className="btn btn-outline-primary"
                        onClick={() => saveServerUrl()}>Set URL</button>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={toggleModalVisibility}>Cancel</button>
                </ModalFooter>
            </Modal>
        </div>
    );
}